<template>
    <div>
        <v-dialog persistent v-model="changePwdDialogStatus" width="580px">
            <v-card>
                <v-card-title align-center>
                    <h3 class="headline" style="color:var(--bindez-green-color);">Change Password</h3>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                            :loading="isPasswordReseting"
                            color="bindezcolor"
                            label="Current Passwords*"
                            solo
                            type="password"
                            v-model="$v.currentPwd.$model"
                            :error-messages="currentPwdErrors"
                            @change="$v.$touch()"
                            :height="45"
                    ></v-text-field>
                    <v-text-field
                            :loading="isPasswordReseting"
                            color="bindezcolor"
                            label="New Passwords*"
                            solo
                            type="password"
                            v-model="$v.newPwd.$model"
                            :error-messages="newPwdErrors"
                            @change="$v.$touch()"
                            :height="45"
                    >
                    </v-text-field>
                    <v-text-field
                            :loading="isPasswordReseting"
                            color="bindezcolor"
                            label="Confirm new Passwords*"
                            solo
                            type="password"
                            v-model="$v.confirmNewPwd.$model"
                            :error-messages="confirmNewPwdErrors"
                            @change="$v.$touch()"
                            :height="45"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="pa-3">
                    <v-btn
                            @click="closeDialog"
                            block
                            color="bindezcolor"
                            large
                            outline
                    >
                        <span class="subheading text-capitalize" style="color:#373737;">Cancel</span>
                    </v-btn>
                    <v-btn @click="updatePassword" block color="bindezcolor" dark large>
                        <span class="subheading text-capitalize">Update Password</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
	import {required, sameAs, minLength, not} from 'vuelidate/lib/validators';
    import {mapActions, mapMutations} from 'vuex';

	export default {
		name: "AppChangePasswordDialog",
		model: {
			prop: "changePwdDialogStatus",
		},
		props: {
			changePwdDialogStatus: {
				required: true,
				type: Boolean,
			}
		},
		data() {
			return {
				currentPwd: null,
				newPwd: null,
				confirmNewPwd: null,
                isPasswordReseting: false,
			}
		},
		computed: {
			currentPwdErrors() {
                let errors = [];
                if(!this.$v.currentPwd.$dirty) return errors;
                !this.$v.currentPwd.required && errors.push("Current password is required");
                return errors;
			},
			newPwdErrors() {
                let errors = [];
                if(!this.$v.newPwd.$dirty) return errors;
                !this.$v.newPwd.required && errors.push("New password is required");
                !this.$v.newPwd.notCurrentPwd && errors.push("New password shouldn't same as current password");
                !this.$v.newPwd.minLength && errors.push("Password require at least 8 characters");
                return errors
			},
			confirmNewPwdErrors() {
                let errors = [];
                if(!this.$v.confirmNewPwd.$dirty) return errors;
                !this.$v.confirmNewPwd.required && errors.push("Confirm password is required");
                !this.$v.confirmNewPwd.sameAsNewPwd && errors.push("Confirm does not match with new password");
                return errors
			}
		},
		methods: {
			...mapActions([
				"changePassword"
            ]),

			...mapMutations('error', [
				"setErrorDialogStatus",
				"setErrorDialogMessage",
				"setErrorStatusCode"
			]),

			...mapMutations([
				"setAlertStatus",
				"setAlertColor",
				"setAlertMessage"
			]),

            resetPasswordFields(){
				this.currentPwd = null;
				this.newPwd = null;
				this.confirmNewPwd = null;
            },

			closeDialog() {
				this.resetPasswordFields();
				this.$v.$reset();
				this.$emit("input", false)
			},

			updatePassword() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.isPasswordReseting = true;
					this.changePassword({current_password: this.currentPwd, new_password: this.newPwd})
						.then(_ => {
							this.$emit("input", false);
							this.resetPasswordFields();
							this.$v.$reset();
							this.setAlertMessage("Your password was successfully updated!");
							this.setAlertColor("#61C58D");
							this.setAlertStatus(true);
						})
						.catch(({response}) => {
							let msg = {"incorrect password": "Your current password is incorrect.Try again."};
							let {data, status} = response;
							let {error:{message}} = data;

							this.setErrorDialogMessage(msg[message]);
							this.setErrorDialogStatus(true);
							this.setErrorStatusCode(status);
						})
						.finally(_ => {
							this.isPasswordReseting = false;
						})
				}
			}
		},
		validations: {
			currentPwd: {
				required
			},
			newPwd: {
				required,
                notCurrentPwd:not(sameAs("currentPwd")),
                minLength:minLength(8)
			},
			confirmNewPwd: {
				required,
				sameAsNewPwd: sameAs("newPwd")
			}
		}
	}
</script>

<style scoped>

</style>
